import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clientWithFork, CustomFieldDto, getNewBranchIdAfterFork } from 'korint-sdk';

type SavePricingSelectionInput = {
  tierId: string;
  policyCustomFields?: CustomFieldDto[];
  branchId?: string;
};

type SavePricingSelectionOutput = {
  saved: boolean;
  newBranchId?: string;
};

export function useSavePricingSelection(policyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: SavePricingSelectionInput): Promise<SavePricingSelectionOutput> => {
      const { branchId, ...body } = input;
      const response = await clientWithFork<{ saved: boolean }>({
        method: 'PUT',
        url: `/pricing/${policyId}/selection`,
        data: body,
        params: branchId ? { branchId } : undefined,
      });
      const newBranchId = getNewBranchIdAfterFork(response.data);
      return { saved: response.data.saved, newBranchId };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['available-pricing', policyId] });
    },
  });
}
